import React, { CSSProperties, FC } from "react";
import cn from "classnames";
import css from "./button.modules.scss";
import TickRightIcon from "@/assets/icons/tick-right.inline.svg";

type ButtonPropsType = {
  onClick?: (e: React.MouseEvent) => void;
  theme?:
    | "primary"
    | "primaryAccent"
    | "secondary"
    | "secondaryAccent"
    | "withoutBorder"
    | "filled"
    | "grey"
    | "formButton"
    | "error";
  className?: string;
  disabled?: boolean;
  type?: "button" | "reset" | "submit";
  style?: CSSProperties;
};

const Button: FC<ButtonPropsType> = ({
  children,
  onClick,
  theme,
  className = "",
  disabled = false,
  type = "button",
  style
}) => {
  const buttonTheme = theme || "primary";

  return (
    <button
      type={type}
      className={cn(
        `flex items-center justify-center text-n1 border-2 px-6 ${css.container} ${className}`,
        {
          [css.primary]: buttonTheme === "primary",
          [css.primaryAccent]: buttonTheme === "primaryAccent",
          [css.secondary]: buttonTheme === "secondary",
          [css.secondaryAccent]: buttonTheme === "secondaryAccent",
          [css.withoutBorder]: buttonTheme === "withoutBorder",
          [css.filled]: buttonTheme === "filled",
          [css.grey]: buttonTheme === "grey",
          [css.formButton]: buttonTheme === "formButton",
          [css.error]: buttonTheme === "error",
        }
      )}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
      {buttonTheme === "formButton" && (
        <TickRightIcon className={`stroke-current`} />
      )}
    </button>
  );
};

export default Button;
